import createAction from './createAction';

// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('../../../node_modules/icepick/icepick.min');

// 1. Initial state
const initialState = icepick.freeze({
  currentFoundLocation: null, // example {location:'London',postcode:'WC2N 5DU'}
  locationServiceLoading: true, // is Location service loading
  pending: false, // when location search pending
  errorMessage: '',
  previouslyUsedLocations: [], // array of LocationDescriptor or null,
  geolocationEnabled: false,
  searchingGeolocation: false
});

// 2. Actions
const SET_CURRENT_FOUND_LOCATION = 'listingPage/locationSearch/SET_CURRENT_FOUND_LOCATION';
const SET_LOCATION_SERVICE_LOADING = 'listingPage/locationSearch/SET_LOCATION_SERVICE_LOADING';
const SET_PENDING = 'listingPage/locationSearch/SET_PENDING';
const SET_ERROR_MESSAGE = 'listingPage/locationSearch/SET_ERROR_MESSAGE';
const SET_PREVIOUSLY_USED_LOCATIONS = 'listingPage/locationSearch/SET_PREVIOUSLY_USED_LOCATIONS';
const SET_GEOLOCATION_ENABLED = 'listingPage/locationSearch/SET_GEOLOCATION_ENABLED';
const SET_SEARCHING_GEOLOCATION = 'listingPage/locationSearch/SET_SEARCHING_GEOLOCATION';

// 3. Action creators
export function setCurrentFoundLocation(data) {
  return createAction(SET_CURRENT_FOUND_LOCATION)(data);
}

export function setLocationServiceLoading(data) {
  return createAction(SET_LOCATION_SERVICE_LOADING)(data);
}

export function setPending(data) {
  return createAction(SET_PENDING)(data);
}

export function setErrorMessage(data) {
  return createAction(SET_ERROR_MESSAGE)(data);
}

export function setPreviouslyUsedLocations(data) {
  return createAction(SET_PREVIOUSLY_USED_LOCATIONS)(data);
}

export function setGeolocationEnabled(data) {
  return createAction(SET_GEOLOCATION_ENABLED)(data);
}

export function setSearchingGeolocation(data) {
  return createAction(SET_SEARCHING_GEOLOCATION)(data);
}

// 4. Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case SET_CURRENT_FOUND_LOCATION: {
      return icepick.setIn(state, ['currentFoundLocation'], action.payload);
    }
    case SET_LOCATION_SERVICE_LOADING: {
      return icepick.setIn(state, ['locationServiceLoading'], action.payload);
    }
    case SET_PENDING: {
      return icepick.setIn(state, ['pending'], action.payload);
    }
    case SET_ERROR_MESSAGE: {
      return icepick.setIn(state, ['errorMessage'], action.payload);
    }
    case SET_PREVIOUSLY_USED_LOCATIONS: {
      return icepick.setIn(state, ['previouslyUsedLocations'], action.payload);
    }
    case SET_GEOLOCATION_ENABLED: {
      return icepick.setIn(state, ['geolocationEnabled'], action.payload);
    }
    case SET_SEARCHING_GEOLOCATION: {
      return icepick.setIn(state, ['searchingGeolocation'], action.payload);
    }
    default: {
      return state;
    }
  }
}
